import styled from '../../../utils/styled';

export default styled('img')({
  width: '100%',
  height: '100%',
  display: 'block'
});



// WEBPACK FOOTER //
// ./src/components/Avatar/private/AvatarImage.tsx